module.exports = __webpack_public_path__ + "static/media/pinned_resume_explain.4c936abb.png";